import React from 'react'
import './AmenitiesT1.scss'
import PropTypes from 'prop-types'
import { EditAmenities } from '@components/custom'
import { EditButtonWrapper } from '@components/common'

export class AmenitiesT1 extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      dialog: false
    }
  }

  handleAmenitiesDialog = () => {
    this.setState({
      dialog: !this.state.dialog
    })
  }

  chunk = (size, xs) =>
    xs.reduce((segments, _, index) => {
      if (index % size === 0) {
        return [...segments, xs.slice(index, index + size)]
      }

      return segments
    }, [])

  render() {
    const {
      editPropertyData,
      amenitiesCount,
      amenities,
      propertyType,
      themeColors,
      disclaimerText,
      showDisclaimer,
      templateName
    } = this.props
    const { dialog } = this.state
    const amenitiesFrmProps = this.props.amenities
    const amenitiesListColumnCount =
      templateName === 'rentComps' || templateName === 'studentHousingComps'
        ? 4
        : templateName === 'rentCompsT4'
        ? 3
        : 2
    const amenitiesInGrp =
      amenitiesFrmProps &&
      this.chunk(amenitiesListColumnCount, amenitiesFrmProps)
    const amenitiesListRowCount = templateName === 'rentCompsT4' ? 2 : 3
    const headingStyle = propertyType?.toString().includes('S')
      ? {
          color: themeColors.subjectSectionHeadingColor
        }
      : {
          color: themeColors.comparableSectionHeadingColor
        }

    const bulletStyle = {
      position: 'relative',
      backgroundColor: propertyType.toString().includes('S')
        ? themeColors.subjectTextbulletColor
        : themeColors.comparableTextbulletColor,
      width: '5px',
      height: '5px',
      display: 'inline-block',
      marginRight: '10px',
      top: '5px',
      borderRadius: '50%'
    }

    return (
      <React.Fragment>
        <div className="amenities">
          <div
            data-testid="amenities"
            className="amenities__heading"
            style={headingStyle}
          >
            AMENITIES
          </div>
          <EditButtonWrapper
            isTruncated={amenities?.length > amenitiesCount}
            handleEditButtonClick={this.handleAmenitiesDialog}
            dataTestId="amenities_edit"
          >
            <div>
              {amenitiesInGrp &&
                amenitiesInGrp.map((list, i) =>
                  (i <= amenitiesListRowCount ? (
                    <div key={i} className="amenities__list">
                      <ul className="amenities__wrap">
                        {list.map((amenitie, j) => {
                          const amenitieItem = amenitie.trim()

                          return (amenitieItem && j <= amenitiesListRowCount) ? (
                            <li key={j}>
                              <div style={bulletStyle} />
                              <div className="amenitie-name">
                                {amenitieItem[0].toUpperCase() +
                                  amenitieItem.substring(1)}
                              </div>
                            </li>
                          ) : (
                            ''
                          )
                        })}
                      </ul>
                    </div>
                  ) : (
                    ''
                  ))
                )}
            </div>
            {showDisclaimer && (
              <div className="amenities__disclaimer">{disclaimerText}</div>
            )}
          </EditButtonWrapper>
        </div>
        <EditAmenities
          disclaimerText={disclaimerText}
          showDisclaimer={showDisclaimer}
          dialog={dialog}
          amenities={amenities}
          chunk={this.chunk}
          editPropertyData={editPropertyData}
          amenitiesCount={amenitiesCount}
          handleAmenitiesDialog={this.handleAmenitiesDialog}
        />
      </React.Fragment>
    )
  }
}

AmenitiesT1.propTypes = {
  disclaimerText: PropTypes.string,
  showDisclaimer: PropTypes.bool,
  amenities: PropTypes.array,
  editPropertyData: PropTypes.func,
  amenitiesCount: PropTypes.number,
  propertyType: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  themeColors: PropTypes.object,
  templateName: PropTypes.string
}

export default AmenitiesT1
